import { Button, minutesToHm } from '@eo/shared';

import type { DaySummaryProps } from './types';

export function DaySummary({
  loggedMinutes,
  unconfirmedMinutes,
  unconfirmedCount,
  busy,
  onConfirmAll,
  action,
}: DaySummaryProps) {
  const total = loggedMinutes + unconfirmedMinutes;
  const pct = total === 0 ? 0 : Math.round((loggedMinutes / total) * 100);

  return (
    <div className="flex flex-wrap items-center justify-between gap-3">
      <div className="min-w-52 flex-1">
        <p className="text-sm text-text-secondary">
          <span className="font-medium text-text-primary">{minutesToHm(loggedMinutes)}</span> logged
          {unconfirmedMinutes > 0 && ` · ${minutesToHm(unconfirmedMinutes)} to confirm`}
        </p>
        <div
          className="mt-1.5 h-1 w-full overflow-hidden rounded-full bg-border-faint"
          role="progressbar"
          aria-valuenow={pct}
          aria-valuemin={0}
          aria-valuemax={100}
          aria-label="Share of the day logged"
        >
          <div
            className="h-full rounded-full bg-success transition-all"
            style={{ width: `${pct}%` }}
          />
        </div>
      </div>

      {/* Both commands act on the day's rows, so they share one action area. */}
      <div className="flex flex-wrap items-center gap-3">
        {unconfirmedCount > 0 && onConfirmAll && (
          <Button size="sm" disabled={busy} onClick={onConfirmAll}>
            Confirm all {unconfirmedCount}
          </Button>
        )}
        {action}
      </div>
    </div>
  );
}
